import { BarChart3, FileBarChart, Megaphone, Sparkles } from 'lucide-react';
import { ContextHero, DataCard, PageContainer, SectionTitle } from '@/components/design-system';

export function ReportingPage(): JSX.Element {
  return (
    <PageContainer>
      <div className="space-y-6">
        <ContextHero
          variant="dashboard"
          icon={<BarChart3 className="h-5 w-5" />}
          title="Reporting"
          subtitle="Module Reporting — bientôt disponible. Tableaux de bord, récap mensuel Direction, performance campagnes."
        />
        <SectionTitle>Aperçu modules à venir</SectionTitle>
        <div className="grid gap-4 md:grid-cols-3">
          <DataCard
            title="Dashboard direction"
            subtitle="Vue consolidée multi-filiales"
            trailing={<FileBarChart className="h-4 w-4 text-slate-400" />}
          >
            <p className="text-sm text-slate-600">
              KPI cross-modules, projection trésorerie, alertes critiques.
            </p>
          </DataCard>
          <DataCard
            title="Récap mensuel DG"
            subtitle="Export PDF automatisé"
            trailing={<Sparkles className="h-4 w-4 text-slate-400" />}
          >
            <p className="text-sm text-slate-600">
              Synthèse Finances + CRM + Formation, signature digitale, envoi mail programmé.
            </p>
          </DataCard>
          <DataCard
            title="Performance campagnes"
            subtitle="Marketing analytics"
            trailing={<Megaphone className="h-4 w-4 text-slate-400" />}
          >
            <p className="text-sm text-slate-600">
              ROI campagnes, leads convertis, sources d&apos;acquisition (Sprint 7).
            </p>
          </DataCard>
        </div>
      </div>
    </PageContainer>
  );
}
